<template>
    <section class="l-section-full story-wrapper" id="app-story">

        <!--- 章セレクタ -->
        <ul class="c-tabmenu c-tabmenu_max-200">
            <li class="c-tabmenu__item">
                <router-link :to="{name:'intro'}" class="c-tabmenu__link">
                    <span class="c-tabmenu__text">Introduction</span>
                </router-link>
            </li>
            <li class="c-tabmenu__item">
                <router-link :to="{name:'story', params:{story:'washio'}}" class="c-tabmenu__link">
                    <span class="c-tabmenu__text">Washio Sumi Chapter</span>
                </router-link>
            </li>
            <li class="c-tabmenu__item" v-if="has_yusha">
                <router-link :to="{name:'story', params:{story:'yusha'}}" class="c-tabmenu__link">
                    <span class="c-tabmenu__text">Hero Chapter</span>
                </router-link>
            </li>
        </ul>

        <!--- ローディング -->
        <transition name="p-v-transition-fade">
            <div class="p-loading p-loading_top-200 p-v-transition-fade" v-if="is_loading"></div>
        </transition>

        <!--- コンテンツ -->
        <transition name="p-v-transition-ud" mode="out-in">
            <router-view :is_loading="is_loading"></router-view>
        </transition>
    </section>
</template>


<script>

// 各話データ
import episode_data from '../../js/page/story/episode_data';

export default {
    data() {
        return {
            is_loading: true
        };
    },
    computed: {
        // 勇者の章が存在するか
        has_yusha() {
            const episode_list = episode_data.get_data('episode_list');
            return Object.keys(episode_list).some(elm => elm === 'yusha');
        }
        // episode_list() {
        //     return episode_data.get_data('episode_list');
        // }
    },
    created() {
        // 読み込みのリスナー登録
        episode_data.$on('LOAD_IMAGES_COMPLETE', () => {
            this.is_loading = false;
        });
        episode_data.$on('LOAD_IMAGES_READY', () => {
            this.is_loading = true;
        });

        // イントロだったら無視
        if (this.$route.path === '/introduction') {
            return;
        }

        // 無指定の場合は最新話
        if (!this.$route.params.id) {
            const story = this.has_yusha ? 'yusha' : 'washio';
            const episode = episode_data.get_last_episode_from_story(story);
            this.$router.push({ name: 'episode', params: { story, id: episode.id } });
        }
    }
};
</script>



// WEBPACK FOOTER //
// story.vue?14c45868